import { render, staticRenderFns } from "./GridPage.vue?vue&type=template&id=96b577cc&"
import script from "./GridPage.vue?vue&type=script&lang=js&"
export * from "./GridPage.vue?vue&type=script&lang=js&"
import style0 from "./GridPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports